import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { Navigation } from 'app/core/navigation/navigation.types';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { User } from 'app/core/user/user.types';
import { UserService } from 'app/core/user/user.service';
import { FetchData } from 'app/shared/generalMethods';

@Component({
    selector: 'classy-layout',
    templateUrl: './classy.component.html',
    encapsulation: ViewEncapsulation.None
})
export class ClassyLayoutComponent implements OnInit, OnDestroy {
    isScreenSmall: boolean;
    navigation: Navigation;
    user: User;
    adminName: string = '';
    staffName: string = '';
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private _router: Router,
        private _navigationService: NavigationService,
        private _userService: UserService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        private _fetchData: FetchData
    ) {}

    ngOnInit(): void {
        // Subscribe to navigation data
        this._navigationService.navigation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((navigation: Navigation) => {
                this.navigation = navigation;
            });

        // Subscribe to user data
        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: User) => {
                this.user = user;
            });

        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({matchingAliases}) => {
                this.isScreenSmall = !matchingAliases.includes('md');
            });

        this.loadNames();
    }

loadNames(): void {
    try {
        this.adminName = '';
        this.staffName = '';

        const data = this._fetchData.data;
        if (data?.lstAdministratorData?.length > 0) {
            const admin = data.lstAdministratorData[0];
            this.adminName = admin.Administrator_Name__c || admin.Name || '';
        } else if (data?.lstStaffData?.length > 0) {
            const staff = data.lstStaffData[0];
            this.staffName = staff.Staff_Name__c || '';
        } else {
            const storedData = JSON.parse(localStorage.getItem('DataSet'));
            if (storedData?.lstAdministratorData?.length > 0) {
                const admin = storedData.lstAdministratorData[0];
                this.adminName = admin.Administrator_Name__c || admin.Name || '';
            } else if (storedData?.lstStaffData?.length > 0) {
                const staff = storedData.lstStaffData[0];
                this.staffName = staff.Staff_Name__c || '';
            }
        }
    } catch (error) {
        console.error('Error loading names:', error);
        this.adminName = '';
        this.staffName = '';
    }
}

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    toggleNavigation(name: string): void {
        const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);
        if (navigation) {
            navigation.toggle();
        }
    }

    signOut(): void {
        localStorage.clear();
        localStorage.removeItem('user-loggedin');
        this._router.navigate(['/sign-out']);
    }
}
